import { generateMockDocLink, simulateFileAttachment, simulateTruckPhoto } from './vehicleConstants';
import { daysUntil } from './complianceUtils';

export const MOVER_STATUSES = ['Available', 'Engaged', 'Maintenance'];
export const ATTACHMENT_STATUSES = ['Available', 'Engaged'];

export const ATTACHMENT_TYPES = [
  'Fuel Tanker',
  'ISO Chassis',
  'B-Double Front',
  'B-Double Rear',
  'Chemical Tanker',
  'LPG Tanker',
  'Flatbed Trailer',
  'Bitumen Tanker',
];

export const EMPTY_MOVER_FORM = {
  plateNumber: '',
  chassisNo: '',
  engineNo: '',
  mulkiyaExpiry: '',
  insuranceExpiry: '',
  dashcamStreamUrl: '',
  status: 'Available',
  moverPhoto: null,
  mulkiyaDoc: null,
  insuranceDoc: null,
};

export const EMPTY_ATTACHMENT_FORM = {
  type: '',
  serialRegistrationNo: '',
  trailerMulkiyaExpiry: '',
  civilDefensePermitExpiry: '',
  status: 'Available',
  unitPhoto: null,
  trailerMulkiyaDoc: null,
  civilDefensePermitDoc: null,
};

const MOCK_HEAD_PHOTO =
  'https://images.unsplash.com/photo-1601584114707-776987970781?w=400&h=280&fit=crop';
const MOCK_HEAD_PHOTO_2 =
  'https://images.unsplash.com/photo-1519005059516-e7a58ee2846e?w=400&h=280&fit=crop';
const MOCK_HEAD_PHOTO_3 =
  'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=400&h=280&fit=crop';
const MOCK_TANKER_PHOTO =
  'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=280&fit=crop';
const MOCK_TANKER_PHOTO_2 =
  'https://images.unsplash.com/photo-1625849616430-f6f5d0b7f0b8?w=400&h=280&fit=crop';
const MOCK_ISO_PHOTO =
  'https://images.unsplash.com/photo-1519003724024-9a87bab113f3?w=400&h=280&fit=crop';
const MOCK_TRAILER_PHOTO =
  'https://images.unsplash.com/photo-1591768793355-74d04bb6608f?w=400&h=280&fit=crop';

function mockPhoto(entityId, docKey, fileName, previewUrl) {
  return {
    fileName,
    previewUrl,
    mockUrl: generateMockDocLink(entityId, docKey, fileName),
    uploadedAt: '2026-01-15',
  };
}

function mockDoc(entityId, docKey, fileName) {
  return {
    fileName,
    mockUrl: generateMockDocLink(entityId, docKey, fileName),
    uploadedAt: '2026-01-15',
  };
}

export const MOCK_MOVERS = [
  {
    id: 'MOV-001',
    plateNumber: 'Mover AU-402',
    makeModel: 'Mercedes-Benz Actros 2545',
    chassisNo: 'WDB9340231L123456',
    engineNo: 'OM471LA-8842-UAE',
    mulkiyaExpiry: '2027-03-15',
    insuranceExpiry: '2027-08-01',
    insuranceProvider: 'Oman Insurance PSC',
    workshopLocation: null,
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-au-402/live',
    status: 'Available',
    moverPhoto: mockPhoto('MOV-001', 'mover-photo', 'mover_au_402_actros.jpg', MOCK_HEAD_PHOTO),
    mulkiyaDoc: mockDoc('MOV-001', 'mover-mulkiya', 'mulkiya_au_402_2027.pdf'),
    insuranceDoc: mockDoc('MOV-001', 'mover-insurance', 'oman_insurance_au_402_policy.pdf'),
  },
  {
    id: 'MOV-002',
    plateNumber: 'Mover DX-881',
    makeModel: 'Volvo FH16 750',
    chassisNo: 'YV2RT40C0NB881204',
    engineNo: 'D13K-750-2291',
    mulkiyaExpiry: '2026-06-18',
    insuranceExpiry: '2027-01-15',
    insuranceProvider: 'Al Ain Ahlia Insurance',
    workshopLocation: null,
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-dx-881/live',
    status: 'Engaged',
    moverPhoto: mockPhoto('MOV-002', 'mover-photo', 'mover_dx_881_fh16.jpg', MOCK_HEAD_PHOTO_2),
    mulkiyaDoc: mockDoc('MOV-002', 'mover-mulkiya', 'mulkiya_dx_881.pdf'),
    insuranceDoc: mockDoc('MOV-002', 'mover-insurance', 'al_ain_insurance_dx_881.pdf'),
  },
  {
    id: 'MOV-003',
    plateNumber: 'Mover SH-109',
    makeModel: 'Scania R500 V8',
    chassisNo: 'YS2R6X20009123456',
    engineNo: 'DC16-109-7710',
    mulkiyaExpiry: '2026-06-17',
    insuranceExpiry: '2026-11-30',
    insuranceProvider: 'Oman Insurance PSC',
    workshopLocation: null,
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-sh-109/live',
    status: 'Available',
    moverPhoto: mockPhoto('MOV-003', 'mover-photo', 'mover_sh_109_scania.jpg', MOCK_HEAD_PHOTO_3),
    mulkiyaDoc: mockDoc('MOV-003', 'mover-mulkiya', 'mulkiya_sh_109_exp_jun17.pdf'),
    insuranceDoc: mockDoc('MOV-003', 'mover-insurance', 'oman_insurance_sh_109.pdf'),
  },
  {
    id: 'MOV-004',
    plateNumber: 'Mover AJ-552',
    makeModel: 'MAN TGX 26.480',
    chassisNo: 'WMA06XZZ0M0552188',
    engineNo: 'D2676LF-5520',
    mulkiyaExpiry: '2026-10-05',
    insuranceExpiry: '2026-08-20',
    insuranceProvider: 'Al Ain Ahlia Insurance',
    workshopLocation: 'OGTS Workshop · Ajman Industrial Zone 2',
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-aj-552/live',
    status: 'Maintenance',
    moverPhoto: mockPhoto('MOV-004', 'mover-photo', 'mover_aj_552_man.jpg', MOCK_HEAD_PHOTO),
    mulkiyaDoc: mockDoc('MOV-004', 'mover-mulkiya', 'mulkiya_aj_552.pdf'),
    insuranceDoc: mockDoc('MOV-004', 'mover-insurance', 'al_ain_insurance_aj_552.pdf'),
  },
  {
    id: 'MOV-005',
    plateNumber: 'Mover RAK-318',
    makeModel: 'DAF XF480 FT',
    chassisNo: 'XLRTE47MS0G318442',
    engineNo: 'MX-13-3180',
    mulkiyaExpiry: '2027-02-28',
    insuranceExpiry: '2026-08-01',
    insuranceProvider: 'National General Insurance',
    workshopLocation: null,
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-rak-318/live',
    status: 'Available',
    moverPhoto: mockPhoto('MOV-005', 'mover-photo', 'mover_rak_318_daf.jpg', MOCK_HEAD_PHOTO_2),
    mulkiyaDoc: mockDoc('MOV-005', 'mover-mulkiya', 'mulkiya_rak_318.pdf'),
    insuranceDoc: mockDoc('MOV-005', 'mover-insurance', 'ngi_rak_318_policy.pdf'),
  },
  {
    id: 'MOV-006',
    plateNumber: 'Mover FUJ-667',
    makeModel: 'Mercedes-Benz Arocs 3363',
    chassisNo: 'WDB9634031L667891',
    engineNo: 'OM473LA-6671',
    mulkiyaExpiry: '2027-05-12',
    insuranceExpiry: '2027-03-22',
    insuranceProvider: 'Oman Insurance PSC',
    workshopLocation: null,
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-fuj-667/live',
    status: 'Engaged',
    moverPhoto: mockPhoto('MOV-006', 'mover-photo', 'mover_fuj_667_arocs.jpg', MOCK_HEAD_PHOTO_3),
    mulkiyaDoc: mockDoc('MOV-006', 'mover-mulkiya', 'mulkiya_fuj_667.pdf'),
    insuranceDoc: mockDoc('MOV-006', 'mover-insurance', 'oman_insurance_fuj_667.pdf'),
  },
  {
    id: 'MOV-007',
    plateNumber: 'Mover UAQ-221',
    makeModel: 'Renault T High 520',
    chassisNo: 'VF624GFA000221778',
    engineNo: 'DXI13-520-2210',
    mulkiyaExpiry: '2027-01-08',
    insuranceExpiry: '2027-06-15',
    insuranceProvider: 'Al Ain Ahlia Insurance',
    workshopLocation: null,
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-uaq-221/live',
    status: 'Available',
    moverPhoto: mockPhoto('MOV-007', 'mover-photo', 'mover_uaq_221_renault.jpg', MOCK_HEAD_PHOTO),
    mulkiyaDoc: mockDoc('MOV-007', 'mover-mulkiya', 'mulkiya_uaq_221.pdf'),
    insuranceDoc: mockDoc('MOV-007', 'mover-insurance', 'al_ain_insurance_uaq_221.pdf'),
  },
  {
    id: 'MOV-008',
    plateNumber: 'Mover AUH-904',
    makeModel: 'Volvo FM 460',
    chassisNo: 'YV2J4X200A904331',
    engineNo: 'D13C-460-9041',
    mulkiyaExpiry: '2026-07-07',
    insuranceExpiry: '2026-12-18',
    insuranceProvider: 'National General Insurance',
    workshopLocation: 'Al Masaood Volvo · Mussafah ICAD',
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-auh-904/live',
    status: 'Maintenance',
    moverPhoto: null,
    mulkiyaDoc: mockDoc('MOV-008', 'mover-mulkiya', 'mulkiya_auh_904.pdf'),
    insuranceDoc: mockDoc('MOV-008', 'mover-insurance', 'ngi_auh_904_policy.pdf'),
  },
  {
    id: 'MOV-009',
    plateNumber: 'Mover DXB-773',
    makeModel: 'Scania G410 XT',
    chassisNo: 'YS2G6X2000773441',
    engineNo: 'DC13-773-4100',
    mulkiyaExpiry: '2026-07-07',
    insuranceExpiry: '2027-04-30',
    insuranceProvider: 'Oman Insurance PSC',
    workshopLocation: null,
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-dxb-773/live',
    status: 'Available',
    moverPhoto: mockPhoto('MOV-009', 'mover-photo', 'mover_dxb_773_scania.jpg', MOCK_HEAD_PHOTO_2),
    mulkiyaDoc: mockDoc('MOV-009', 'mover-mulkiya', 'mulkiya_dxb_773.pdf'),
    insuranceDoc: mockDoc('MOV-009', 'mover-insurance', 'oman_insurance_dxb_773.pdf'),
  },
  {
    id: 'MOV-010',
    plateNumber: 'Mover ALN-445',
    makeModel: 'Iveco S-Way AS440S51',
    chassisNo: 'ZCFC535C505445112',
    engineNo: 'CURSOR13-4450',
    mulkiyaExpiry: '2027-09-01',
    insuranceExpiry: '2026-07-20',
    insuranceProvider: 'Al Ain Ahlia Insurance',
    workshopLocation: null,
    dashcamStreamUrl: 'rtsp://dashcam.ogts.ae/mov-aln-445/live',
    status: 'Available',
    moverPhoto: mockPhoto('MOV-010', 'mover-photo', 'mover_aln_445_iveco.jpg', MOCK_HEAD_PHOTO_3),
    mulkiyaDoc: mockDoc('MOV-010', 'mover-mulkiya', 'mulkiya_aln_445.pdf'),
    insuranceDoc: mockDoc('MOV-010', 'mover-insurance', 'al_ain_insurance_aln_445.pdf'),
  },
];

export const MOCK_ATTACHMENTS = [
  {
    id: 'ATT-001',
    type: 'Fuel Tanker',
    serialRegistrationNo: 'Tanker TK-101 · 35,000L Single',
    capacityLitres: 35000,
    adrCertified: true,
    isoSlots: null,
    trailerMulkiyaExpiry: '2027-04-18',
    civilDefensePermitExpiry: '2027-02-10',
    status: 'Available',
    unitPhoto: mockPhoto('ATT-001', 'unit-photo', 'tanker_tk_101_35kl.jpg', MOCK_TANKER_PHOTO),
    trailerMulkiyaDoc: mockDoc('ATT-001', 'trailer-mulkiya', 'mulkiya_tk_101_adr.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-001', 'civil-defense', 'adr_cert_tk_101.pdf'),
  },
  {
    id: 'ATT-002',
    type: 'B-Double Front',
    serialRegistrationNo: 'Tanker TK-102 · B-Double 25k+20k L',
    capacityLitres: 45000,
    adrCertified: true,
    isoSlots: null,
    trailerMulkiyaExpiry: '2027-06-30',
    civilDefensePermitExpiry: '2027-01-25',
    status: 'Engaged',
    unitPhoto: mockPhoto('ATT-002', 'unit-photo', 'tanker_tk_102_bdouble.jpg', MOCK_TANKER_PHOTO_2),
    trailerMulkiyaDoc: mockDoc('ATT-002', 'trailer-mulkiya', 'mulkiya_tk_102_bdouble.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-002', 'civil-defense', 'civil_defense_tk_102.pdf'),
  },
  {
    id: 'ATT-003',
    type: 'ISO Chassis',
    serialRegistrationNo: 'ISO Chassis CH-305 · 2-Slot',
    capacityLitres: null,
    adrCertified: false,
    isoSlots: 2,
    trailerMulkiyaExpiry: '2027-08-14',
    civilDefensePermitExpiry: '2026-06-15',
    status: 'Available',
    unitPhoto: mockPhoto('ATT-003', 'unit-photo', 'iso_ch_305_2slot.jpg', MOCK_ISO_PHOTO),
    trailerMulkiyaDoc: mockDoc('ATT-003', 'trailer-mulkiya', 'mulkiya_ch_305.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-003', 'civil-defense', 'cd_inspection_ch_305_jun15.pdf'),
  },
  {
    id: 'ATT-004',
    type: 'Flatbed Trailer',
    serialRegistrationNo: 'Flexi-Tank FL-901 · 24,000L bladder',
    capacityLitres: 24000,
    adrCertified: false,
    isoSlots: null,
    trailerMulkiyaExpiry: '2027-03-08',
    civilDefensePermitExpiry: '2026-11-05',
    status: 'Available',
    unitPhoto: mockPhoto('ATT-004', 'unit-photo', 'flexi_fl_901.jpg', MOCK_TRAILER_PHOTO),
    trailerMulkiyaDoc: mockDoc('ATT-004', 'trailer-mulkiya', 'mulkiya_fl_901.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-004', 'civil-defense', 'civil_defense_fl_901.pdf'),
  },
  {
    id: 'ATT-005',
    type: 'Chemical Tanker',
    serialRegistrationNo: 'Chemical CHM-204 · 28,000L ADNOC',
    capacityLitres: 28000,
    adrCertified: true,
    isoSlots: null,
    trailerMulkiyaExpiry: '2027-07-22',
    civilDefensePermitExpiry: '2027-05-30',
    status: 'Engaged',
    unitPhoto: mockPhoto('ATT-005', 'unit-photo', 'chemical_chm_204.jpg', MOCK_TANKER_PHOTO),
    trailerMulkiyaDoc: mockDoc('ATT-005', 'trailer-mulkiya', 'mulkiya_chm_204.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-005', 'civil-defense', 'adnoc_hazmat_chm_204.pdf'),
  },
  {
    id: 'ATT-006',
    type: 'Bitumen Tanker',
    serialRegistrationNo: 'Bitumen BT-880 · 40,000L insulated',
    capacityLitres: 40000,
    adrCertified: false,
    isoSlots: null,
    trailerMulkiyaExpiry: '2026-07-22',
    civilDefensePermitExpiry: '2027-08-01',
    status: 'Available',
    unitPhoto: mockPhoto('ATT-006', 'unit-photo', 'bitumen_bt_880.jpg', MOCK_TANKER_PHOTO_2),
    trailerMulkiyaDoc: mockDoc('ATT-006', 'trailer-mulkiya', 'mulkiya_bt_880.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-006', 'civil-defense', 'civil_defense_bt_880.pdf'),
  },
  {
    id: 'ATT-007',
    type: 'LPG Tanker',
    serialRegistrationNo: 'LPG Tanker LPG-112 · 25,000L',
    capacityLitres: 25000,
    adrCertified: true,
    isoSlots: null,
    trailerMulkiyaExpiry: '2027-10-01',
    civilDefensePermitExpiry: '2027-06-18',
    status: 'Available',
    unitPhoto: mockPhoto('ATT-007', 'unit-photo', 'lpg_112_tanker.jpg', MOCK_TANKER_PHOTO),
    trailerMulkiyaDoc: mockDoc('ATT-007', 'trailer-mulkiya', 'mulkiya_lpg_112.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-007', 'civil-defense', 'emirates_gas_lpg_112.pdf'),
  },
  {
    id: 'ATT-008',
    type: 'Flatbed Trailer',
    serialRegistrationNo: 'Trailer FB-550 · 4-Axle low-loader',
    capacityLitres: null,
    adrCertified: false,
    isoSlots: null,
    trailerMulkiyaExpiry: '2027-12-01',
    civilDefensePermitExpiry: '2027-09-15',
    status: 'Available',
    unitPhoto: mockPhoto('ATT-008', 'unit-photo', 'flatbed_fb_550.jpg', MOCK_TRAILER_PHOTO),
    trailerMulkiyaDoc: mockDoc('ATT-008', 'trailer-mulkiya', 'mulkiya_fb_550.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-008', 'civil-defense', 'civil_defense_fb_550.pdf'),
  },
  {
    id: 'ATT-009',
    type: 'Fuel Tanker',
    serialRegistrationNo: 'Tanker TK-205 · 42,000L 5-Axle',
    capacityLitres: 42000,
    adrCertified: true,
    isoSlots: null,
    trailerMulkiyaExpiry: '2027-05-05',
    civilDefensePermitExpiry: '2026-07-28',
    status: 'Available',
    unitPhoto: mockPhoto('ATT-009', 'unit-photo', 'tanker_tk_205_5axle.jpg', MOCK_TANKER_PHOTO_2),
    trailerMulkiyaDoc: mockDoc('ATT-009', 'trailer-mulkiya', 'mulkiya_tk_205.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-009', 'civil-defense', 'enoc_permit_tk_205.pdf'),
  },
  {
    id: 'ATT-010',
    type: 'B-Double Rear',
    serialRegistrationNo: 'Tanker TK-102R · B-Double Rear 20,000L',
    capacityLitres: 20000,
    adrCertified: true,
    isoSlots: null,
    trailerMulkiyaExpiry: '2027-06-30',
    civilDefensePermitExpiry: '2027-01-25',
    status: 'Engaged',
    unitPhoto: mockPhoto('ATT-010', 'unit-photo', 'tanker_tk_102r_rear.jpg', MOCK_TANKER_PHOTO),
    trailerMulkiyaDoc: mockDoc('ATT-010', 'trailer-mulkiya', 'mulkiya_tk_102r.pdf'),
    civilDefensePermitDoc: mockDoc('ATT-010', 'civil-defense', 'civil_defense_tk_102r.pdf'),
  },
];

export const MOCK_ACTIVE_COUPLINGS = [
  {
    id: 'CPL-001',
    moverId: 'MOV-002',
    attachmentId: 'ATT-002',
    coupledAt: '2026-06-11T05:45:00',
    routeStatus: 'In-Transit',
    routeLabel: 'ENOC Jebel Ali → ADNOC Ruwais · Diesel B-Double (TK-102)',
  },
  {
    id: 'CPL-002',
    moverId: 'MOV-006',
    attachmentId: 'ATT-005',
    coupledAt: '2026-06-12T02:15:00',
    routeStatus: 'Loading',
    routeLabel: 'ADNOC Sour Gas · Jebel Ali Port · Chemical CHM-204',
  },
  {
    id: 'CPL-003',
    moverId: 'MOV-002',
    attachmentId: 'ATT-010',
    coupledAt: '2026-06-11T05:46:00',
    routeStatus: 'In-Transit',
    routeLabel: 'B-Double rear segment · piggyback on CPL-001 convoy',
  },
];

export function generateMoverId(movers) {
  const nums = movers.map((m) => parseInt(m.id.replace('MOV-', ''), 10));
  return `MOV-${String(Math.max(0, ...nums) + 1).padStart(3, '0')}`;
}

export function generateAttachmentId(attachments) {
  const nums = attachments.map((a) => parseInt(a.id.replace('ATT-', ''), 10));
  return `ATT-${String(Math.max(0, ...nums) + 1).padStart(3, '0')}`;
}

export function generateCouplingId(couplings) {
  const nums = couplings.map((c) => parseInt(c.id.replace('CPL-', ''), 10));
  return `CPL-${String(Math.max(0, ...nums) + 1).padStart(3, '0')}`;
}

export function moverToForm(mover) {
  return {
    plateNumber: mover.plateNumber,
    chassisNo: mover.chassisNo || '',
    engineNo: mover.engineNo || '',
    mulkiyaExpiry: mover.mulkiyaExpiry || '',
    insuranceExpiry: mover.insuranceExpiry || '',
    dashcamStreamUrl: mover.dashcamStreamUrl || '',
    status: mover.status,
    moverPhoto: mover.moverPhoto || null,
    mulkiyaDoc: mover.mulkiyaDoc || null,
    insuranceDoc: mover.insuranceDoc || null,
  };
}

export function attachmentToForm(attachment) {
  return {
    type: attachment.type,
    serialRegistrationNo: attachment.serialRegistrationNo,
    trailerMulkiyaExpiry: attachment.trailerMulkiyaExpiry || '',
    civilDefensePermitExpiry: attachment.civilDefensePermitExpiry || '',
    status: attachment.status,
    unitPhoto: attachment.unitPhoto || null,
    trailerMulkiyaDoc: attachment.trailerMulkiyaDoc || null,
    civilDefensePermitDoc: attachment.civilDefensePermitDoc || null,
  };
}

export function buildMoverFromForm(form, id) {
  return {
    id,
    plateNumber: form.plateNumber.trim(),
    chassisNo: form.chassisNo.trim(),
    engineNo: form.engineNo.trim(),
    mulkiyaExpiry: form.mulkiyaExpiry,
    insuranceExpiry: form.insuranceExpiry,
    dashcamStreamUrl: form.dashcamStreamUrl.trim() || `rtsp://dashcam.ogts.ae/${id.toLowerCase()}/live`,
    status: form.status,
    moverPhoto: form.moverPhoto,
    mulkiyaDoc: form.mulkiyaDoc,
    insuranceDoc: form.insuranceDoc,
  };
}

export function buildAttachmentFromForm(form, id) {
  return {
    id,
    type: form.type,
    serialRegistrationNo: form.serialRegistrationNo.trim(),
    trailerMulkiyaExpiry: form.trailerMulkiyaExpiry,
    civilDefensePermitExpiry: form.civilDefensePermitExpiry,
    status: form.status,
    unitPhoto: form.unitPhoto,
    trailerMulkiyaDoc: form.trailerMulkiyaDoc,
    civilDefensePermitDoc: form.civilDefensePermitDoc,
  };
}

export function simulateMoverPhoto(file, entityId) {
  return simulateTruckPhoto(file, entityId);
}

export function simulateUnitPhoto(file, entityId) {
  return simulateTruckPhoto(file, entityId);
}

export function simulateAssetDoc(file, entityId, docKey) {
  return simulateFileAttachment(file, entityId, docKey);
}

export function formatCoupledAt(isoStr) {
  return new Intl.DateTimeFormat('en-AE', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Dubai',
  }).format(new Date(isoStr));
}

function pushExpiryAlert(alerts, label, dateStr) {
  const days = daysUntil(dateStr);
  if (days > 30) return;
  alerts.push({
    text: `${label} ${days <= 7 ? 'CRITICAL' : 'expiring'}`,
    severity: days <= 7 ? 'critical' : 'warning',
  });
}

export function getCouplingComplianceAlerts(mover, attachment) {
  const alerts = [];
  if (!mover || !attachment) return alerts;

  pushExpiryAlert(alerts, 'Mover Mulkiya', mover.mulkiyaExpiry);
  pushExpiryAlert(alerts, 'Mover Insurance', mover.insuranceExpiry);
  pushExpiryAlert(alerts, 'Trailer Mulkiya', attachment.trailerMulkiyaExpiry);
  pushExpiryAlert(alerts, 'Civil Defense permit', attachment.civilDefensePermitExpiry);
  return alerts;
}

export function getFleetComplianceSummary(movers, attachments) {
  const criticalItems = [];
  const warningItems = [];
  let valid = 0;

  const evaluate = (label, dateStr) => {
    const days = daysUntil(dateStr);
    if (days <= 7) criticalItems.push({ label, dateStr, days });
    else if (days <= 60) warningItems.push({ label, dateStr, days });
    else valid += 1;
  };

  movers.forEach((m) => {
    if (m.mulkiyaExpiry) evaluate(`${m.plateNumber} · Mulkiya`, m.mulkiyaExpiry);
    if (m.insuranceExpiry) evaluate(`${m.plateNumber} · Insurance`, m.insuranceExpiry);
  });
  attachments.forEach((a) => {
    const unit = a.serialRegistrationNo?.split(' · ')[0] || a.serialRegistrationNo;
    if (a.trailerMulkiyaExpiry) evaluate(`${unit} · Mulkiya`, a.trailerMulkiyaExpiry);
    if (a.civilDefensePermitExpiry) evaluate(`${unit} · Civil Defense`, a.civilDefensePermitExpiry);
  });

  return {
    critical: criticalItems.length,
    warning: warningItems.length,
    valid,
    criticalItems,
    warningItems,
  };
}
